/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';

import './TakePhotoButton.css';
import TakePhotoModal from '../TakePhotoModal/TakePhotoModal';

// If the backend returns a Google Drive download URL, convert it to a
// thumbnail URL so the browser can actually render it as an image.
// This lives here because the API returns the raw Drive URL and we
// cannot change the backend response at this time.
const toDisplaySrc = (src) => {
  if (src && typeof src === 'string' && src.includes('drive.google.com')) {
    return src
      .replace('&export=download', '')
      .replace('/uc?', '/thumbnail?');
  }
  return src;
};

class TakePhotoButton extends React.Component {
  constructor(props) {
    super(props);
    this.showPhotoModal = this.showPhotoModal.bind(this);
    this.hidePhotoModal = this.hidePhotoModal.bind(this);

    this.state = {
      Image: props.Image || '',
      showModal: false,
    };
  }

  // Sync incoming prop changes (e.g. when parent re-fetches vehicle data on revisit)
  componentDidUpdate(prevProps) {
    if (this.props.Image !== prevProps.Image) {
      this.setState({ Image: this.props.Image || '' });
    }
  }

  hidePhotoModal() {
    this.setState({ showModal: false });
  }

  showPhotoModal() {
    this.setState({ showModal: true });
  }

  render() {
    const isValidImage = this.state.Image
      && this.state.Image.trim() !== ''
      && this.state.Image !== 'null';

    const displaySrc = toDisplaySrc(this.state.Image);

    return (
      <div>
        <div className="col-xs-12 col-lg-6 text-center">
          <div
            className="col-xs-12 text-center img-card"
            style={{ float: 'none' }}
          >
            <div className="text-center img-title">{this.props.ImageTitle}</div>
            &nbsp;

            {isValidImage ? (
              <img
                src={displaySrc}
                className="photo take-photo-button rounded-corners"
                alt={this.props.ImageTitle}
              />
            ) : (
              <div
                className="photo take-photo-button rounded-corners"
                style={{
                  border: '1px solid #ccc',
                  minHeight: '180px',
                  width: '100%',
                  backgroundColor: '#f9f9f9',
                }}
              />
            )}

            <button
              className="newBtn btn-success col-xs-12 updateSteps"
              style={{ marginTop: '5px' }}
              onClick={this.showPhotoModal}
            >
              {isValidImage ? 'Update Photo' : 'Take Photo'}
            </button>
          </div>
        </div>

        {this.state.showModal && (
          <TakePhotoModal
            ImageName={this.props.ImageName}
            Hide={this.hidePhotoModal}
            Action={(image, imageName) => {
              this.setState({ Image: image });
              this.props.Action(image, imageName);
            }}
          />
        )}
      </div>
    );
  }
}

TakePhotoButton.propTypes = {
  ImageTitle: PropTypes.string.isRequired,
  ImageName: PropTypes.string.isRequired,
  Action: PropTypes.func.isRequired,
  Image: PropTypes.string,
};

export default TakePhotoButton;
